import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { PButtonComponent } from '../../../../shared/design-system/atoms/p-button/p-button.component';
import { SignUpStoreService } from '../../../services/sign-up-store/sign-up-store.service';

@Component({
  selector: 'app-inscription-confirmation',
  standalone: true,
  imports: [PButtonComponent],
  templateUrl: './inscription-confirmation.component.html',
  styleUrl: './inscription-confirmation.component.scss',
})
export class InscriptionConfirmationComponent implements OnDestroy {
  email = '-';

  constructor(
    private router: Router,
    private signUpStoreService: SignUpStoreService,
  ) {
    this.email = this.signUpStoreService.getInformationsSnapshot().email ?? '-';
  }

  ngOnDestroy(): void {
    this.signUpStoreService.reset();
  }

  goHome(): void {
    this.router.navigate(['/']);
  }
}
